// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"472":"settings","792":"main"}[chunkId] + "-" + {"472":"c252a","792":"199b6"}[chunkId] + ".css";
};